import styled from 'styled-components';
import { backgroundColor, primaryBoxShadow, primaryText } from 'styles/theme';

export const ComponentContainer = styled.div`
    background: ${backgroundColor};
    color: ${primaryText};
    border-radius: 4px;
    box-shadow: ${primaryBoxShadow};
    flex-basis: 20%;
`;
